import { initClient } from 'rwsdk/client';

import { initPostHog } from '@/lib/posthog.client';

import './global.css';

// Initialize PostHog for client-side analytics
initPostHog();

initClient();
